import { Component, OnInit, Input, ElementRef, OnChanges, Renderer2 } from '@angular/core';

@Component({
    selector: 'app-svg-icon',
    template: '',
    styleUrls: ['./svg-icon.component.scss']
})
export class SvgIconComponent implements OnInit, OnChanges {
    @Input() src: string;

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {}

    ngOnChanges() {
        this.renderer.setProperty(this.elementRef.nativeElement, 'innerHTML', this.src || '');
    }
}
